<template>
  <div class="readingDetail">
      <div class="reading-main">
        <p class="tit clearfix">
            <span><a href="/">首页</a></span>
            <!-- <span class="arr-bold">&gt;</span> -->
            <!-- <span>亚商读书会</span> -->
            <span class="arr-bold">&gt;</span>
            <span><a href="/readingParty">读书列表</a></span>
            <span class="arr-bold">&gt;</span>
            <span class="font-blue">读书会详情</span>
        </p>
        <div class="content">
            <div v-if="readingId == item.id"  v-for="(item, index) in detailList" :key="item.id">
                <p class="title">{{item.title}}</p>
                <div class="book-info">
                    <div class="clearfix">
                        <span class="fl"><img :src="item.bookPic" alt=""></span>
                        <div class="book-detail fl">
                            <p>主讲嘉宾：<span class="font-bold">{{item.speaker}}</span></p>
                            <p>主讲书籍：<span class="font-bold">{{item.book}}</span></p>
                            <!-- <p>主讲嘉宾：<span class="font-bold">{{item.guest}}</span></p> -->
                            <p>互动嘉宾：<span class="font-bold">{{item.Interaction}}</span></p>
                        </div>
                    </div>
                    <p class="title1">活动现场照片</p>
                    <div class="swiper">
                        <swiper :options="swiperOption">
                            <swiper-slide v-for="(slide, index) in item.pic" :key="index">
                                <img :src="slide" alt="" >
                            </swiper-slide>
                                <div class="swiper-pagination" slot="pagination"></div>
                                <!-- <div class="swiper-button-next"></div>
                                <div class="swiper-button-prev"></div> -->
                        </swiper>
                    </div>
                    <p class="title">{{item.theme}}</p>
                    <p class="feeling" v-for="(items, index) in item.text" :key="index">{{items}}</p>
                </div>
            </div>
        </div>
      </div>
      <go-top></go-top>
  </div>
</template>

<script>
import book1 from './book1.png'
import book2 from './book2.png'
import book3 from './book3.png'
import book4 from './book4.png'
import book5 from './book5.jpg'
import slide1 from './dsh1-1.png'
import slide2 from './dsh1-2.png'
import slide3 from './dsh2-1.png'
import slide4 from './dsh2-2.png'
import slide5 from './dsh3-1.png'
import slide6 from './dsh3-2.png'
import slide7 from './dsh4-1.png'
import slide8 from './dsh4-2.png'
import slide9 from './dsh5-1.jpg'
import slide10 from './dsh5-2.jpg'
import slide11 from './dsh5-3.jpg'
import slide12 from './dsh5-4.jpg'
import slide13 from './dsh5-5.jpg'
import slide14 from './dsh5-6.jpg'
import slide15 from './dsh5-7.jpg'
import slide16 from './dsh5-8.jpg'
import slide17 from './dsh5-9.jpg'
import goTop from "../../common/go-top.vue";
export default {
  name: 'ReadingDetail',
  components: {
    goTop
  },
  data(){
      return {
        readingId: this.$route.params.id || null,
        swiperOption: {
              pagination : {
                  el: '.swiper-pagination',
                  clickable: true,
                  // bulletActiveClass: 'my-bullet-active'
              },
              autoplay: {delay: 4000},
              loop: true,
              loopFillGroupWithBlank: true,
              slidesPerView: 3,
              spaceBetween: 30,
              slidesPerGroup: 3,
              navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
              },
          },
        detailList: [
            {
                id: 0,
                title: '读书会 第一期 主题：我读一本书 足以慰风尘',
                bookPic: book1,
                speaker: '周瑞金 蔡洪平  田仁灿',
                book: '《皇甫平改革诤言录》',
                Interaction: '王仁定、徐子望',
                pic: [slide1, slide2],
                theme: '主题：我读一本书 足以慰风尘',
                text: ['周瑞金。说周老先生大家还需要想一下，可是说起老先生的笔名“皇甫平”确实如雷贯耳。了解中国改革38年的各位当年一定也是在解放日报头版头条拜读过周老的文章和政论。',
            '周老演讲对38年的改革有着高屋建瓴的系统视野，非常有价值。今天的改革，也不应忘记“初心”。本次读书会上老先生主要和各位分享了最具代表性的两本，《皇甫平改革诤言录》和《皇甫平：中国改革何处去》。两本著作的前言和附录，以及书中四篇是周老思想的高度概括。',
            '田仁灿先生精通多国语言，涉猎心理，哲学，文学，金融等多个领域。分享由读书展开，延伸到自我价值的认识和体现：通过读书来学习技能也是尤为重要的；而更重要的是通过读书丰富思想，探索世界，树立价值观，形成自我判断力。',
            '蔡洪平先生从自己少年时代（1970年前后）的时政现象开始，聊学校，聊同学，聊生活，聊下乡，聊读书。从简单平凡的故事中逐步展开读书对他的影响：好的读书会首先应该讲真话，虽然不一定是真理。'
          ]
            },
            {
                id: 1,
                title: '读书会 第二期 主题：无竹则俗 无书则浮',
                bookPic: book2,
                speaker: '张醒生 汪潮涌 陈琦伟',
                book: '《圆明园四十景》',
                Interaction: '张克夫',
                pic: [slide3, slide4],
                theme: '主题：无竹则俗 无书则浮',
                text: ['第二期亚商读书会走出上海在安吉开展。由于是俱乐部性质的私下邀请，本次在没有大规模邀请的前提下有70位嘉宾从各地赶来安吉参加读书会也是着实让主办方的工作人员十分感动。',
             '我们也会再接再厉把读书会扩大到每位有兴趣的读书郎都有机会能够参加。'

          ]
            },
            {
                id: 2,
                title: '读书会 第三期 主题：那十年 影响我们的一本书',
                bookPic: book3,
                speaker: '王开国 孙恒志 李若谷',
                book: '《中国近代史》',
                Interaction: '陈琦伟',
                pic: [slide5,slide6],
                theme: '主题：那十年 影响我们的一本书',
                text: ['80年代是最值得回味的十年，改革开放所带来的新文化，新思想，新理念在这十年之间疯狂引进，尽情迸发。没有手机，电脑普及的那十年，书籍是充实心灵最好的工具。一本书，可以阅后即焚，可也以改变一生。']
            },
            {
                id: 3,
                title: '读书会 第四期 主题：坚毅如山 平静如水',
                bookPic: book4,
                speaker: '王静',
                book: '无',
                Interaction: '蒋昌建',
                pic: [slide7,slide8],
                theme: '主题：坚毅如山 平静如水',
                text: ['第一位全程无氧登顶海拔7855米努子峰的中国人',
            '第一位从南坡登顶海拔8844.43米珠穆朗玛峰的中国内地女性',
            '第一位3次从南坡登顶珠穆朗玛峰的中国女性',
            '第四期读书会邀请到的是登山家王静女士来到现场为我们分享她的',
            '登山故事，她的心路历程']
            },
            {
                id: 4,
                title: '读书会 第五期 主题：真善美之间的逻辑关系',
                bookPic: book5,
                speaker: '曹兴诚先生',
                book: '无',
                Interaction: '陈琦伟 戴志康 王仁定',
                pic: [slide9,slide10,slide11,slide12,slide13,slide14,slide15,slide16,slide17],
                theme: '主题：真善美之间的逻辑关系',
                text: ['2018年5月15日下午4点，亚商读书会与大商学院联合举办的新一期读书会活动如期开讲。华人世界顶级收藏家曹兴诚先生用了两个多小时为大家分享了他对于真善美、科学、佛学的理解。',
            '读书会期间曹先生侃侃而谈，先是从蜘蛛提到了佛学概念里的“本觉本知”。从《西方的智慧》中提炼出“科学求真、宗教求善、艺术求美”的精髓，为大家展开了自己的解读。以水举例，用佛学的理念诠释出追求事物本质的途径，以此引出对科学的理解——“精神、方法、结果”。',
            '接着又细致展开了对“科学”和“技术”之间相互关系的认识。并用霍金、哥白尼、爱因斯坦的案例，讲述了科学模型建立的重要性。提出观点：“真善美”最重要的“逻辑技术”就是——发现。而宗教、科学、艺术在曹兴诚先生眼中都是相通的，都是通过发现，验证，建立模型来实现的。',
            '随后应现场观众的提问，阐述了自身对佛学多年研究后的深刻认识，让在场的各位听众受益良多。曹兴诚先生还提出了“闻、思、修”的学习方法，告诫大家不仅要听他人的思想，更要形成自己的认识，辩证实践才能得出真正对于佛学的认知，这也是一种科学的精神。',
            '以下是精彩演讲节选：',
                          '“我们看科学可以分三个层次：',
                          '一是科学精神：越过表象看本质。',
                          '二是科学方法：霍金的《时间简史》把很前沿的东西，深入浅出地让每个人都看得懂。在《时间简史》里面，他提出很重要的理论，model dependent realism（模型源于实相）。我们要先建立一个模型，我们对世界的了解，脱离model不可能，比如我们对动物的认识，先是见到物或图形，有理论介绍。如果现在进来一个蛇头人身的东西，我们就坐不住了，因为我们没有见过这样的model。',
                          '三是科学成果。',
                          '首先，我们来看看科学和技术的区别是什么？科学就是知识，是我们对宇宙的了解。技术是制作器物的方法（know how）。技术远远早于科学，我们最早的技术是钻木取火。没有火之前，人类有三种躲避寒冷的模式：逃跑（从冷的地方到暖和的地方、毛皮（保暖）、冬眠（改变基因，适应社会），而火让人类完全脱离了原始的状态。火就是技术而不是科技。',
                          '所以，从科学的发现过程，我们就可以看出有一个共通的特征：发现，即发现事物本来的样子。',
                          '科学的过程就是发现规律，找出因果加以确定，造出模型，这个过程就是科学。',
                          '宗教也想去找出规律、因果，艺术也是这样的，毕加索说：我只是发现美好的东西，不是创作。这不是他谦虚，而是他找到了艺术的本质。无中生有都是创造，发现就是找到本来的规律。”']
            }
        ]
      }
  }
}
</script>

<style scoped>
.swiper-button-next,.swiper-button-prev{
    z-index: 9999;
}
.swiper{
    margin-bottom: 40px;
    padding: 0 24px;
}
/* .swiper .bulletActiveClass{
    background: red;
} */
/* .swiper-pagination-bullet{
    background: #fff;
    opacity: 0.7;
} */
.readingDetail{
    min-width: 1200px;
}
.banner{
  width: 100%;
}
.reading-main{
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 48px;
}
.reading-main .tit{
    height: 46px;
    line-height: 46px;
    font-size: 14px;
    text-align: left;
}
.reading-main .tit a{
    color: #333;
}
.reading-main .tit span{
    cursor: pointer;
}
.reading-main .arr-bold{
  font-weight: 600;
}
.reading-main .font-blue{
  color: #003B83;
}
.reading-main .content{
    background: #fff;
    padding: 44px 98px;
}
.reading-main .content p{
    text-align: left;
}
.reading-main .content .title{
    font-size: 20px;
    color: #333;
    font-weight: 600;
    margin-bottom: 24px;
}
.reading-main .content .title1{
    font-size: 16px;
    color: #333;
    font-weight: 600;
    line-height: 32px;
    margin: 24px 0 10px 0;
}
.reading-main .book-detail{
    margin-left: 18px;
    /* margin-top: 115px; */
    margin-top: 15%;
}
.reading-main .book-detail p{
    color: #666;
    font-size: 14px;
    line-height: 28px;
}
.reading-main .book-detail .font-bold{
    font-weight: 600;
    color: #333;
}
.reading-main .feeling{
    line-height: 24px;
    color: #666;
    margin-bottom: 24px;
}
 @media screen and (max-width: 1024px){
     .readingDetail .reading-main{
         max-width: 1200px !important;
     }
 }
</style>




// WEBPACK FOOTER //
// src/components/readingDetail/ReadingDetail.vue